
<style scoped>
.bg-primary {
  background-color: #1a3665 !important;
}
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn-upload {
  border: 2px solid gray;
  color: gray;
  background-color: white;
  padding: 5px 15px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 30px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.collapse-arrow .feather-icon {
  transform: rotate(-180deg);
  transition: 0.3s transform ease-in-out;
  display: inline-block;
}

.collapsed .collapse-arrow .feather-icon {
  transform: rotate(0deg);
}
.nav-tabs .nav-link {
  color: black;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #24519c !important;
  font-weight: bold !important;
  background: none !important;
  border: none !important;
}
</style>
<template>
  <div class="row justify-content-center">
    <div class="col-12">
      <div class="row">
        <div class="tab-content col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" id="nav-tabContent">
          <div class="mt-3 tab-pane fade show active" id="nav-data-petugas" role="tabpanel" aria-labelledby="nav-data-petugas-tab">
            <div class="card">
              <div class="card-header bg-primary text-white font-weight-bold d-flex align-items-center justify-content-between">Data Petugas LMS
                <button class="btn btn-dark ml-auto" @click="$router.go(-1)">Kembali</button>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-8 order-2 order-sm-2 order-md-1 order-lg-1 order-xl-1">
                    <div v-on:submit.prevent="postData">
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="name" class="font-weight-bold">Nama Petugas</label>
                          <input
                            type="text"
                            class="form-control"
                            id="name"
                            v-model="formData.name"
                            placeholder="Masukkan Nama Petugas"
                            :class="{
                              'is-invalid': $v.formData.name.$error
                            }"
                          />
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="email" class="font-weight-bold">Email Petugas</label>
                          <input
                            type="email"
                            class="form-control"
                            id="email"
                            v-model="formData.email"
                            placeholder="Masukkan Email Petugas"
                            :class="{
                              'is-invalid': $v.formData.email.$error
                            }"
                          />
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="divisi" class="font-weight-bold">Divisi</label>
                          <multiselect
                            label="namaDivisi"
                            required
                            placeholder="Pilih Divisi"
                            @input="pilihDivisi"
                            v-model="multi_master_divisi"
                            :options="optionMasterDivisi"   
                            :class="{
                              'has-error': $v.multi_master_divisi.$error
                            }"                         
                          ></multiselect>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="cabang" class="font-weight-bold">Cabang</label>
                          <multiselect
                            label="namaCabang"
                            required
                            placeholder="Pilih Cabang"
                            @input="pilihCabang"
                            v-model="multi_master_cabang"
                            :options="optionMasterCabang"  
                            :class="{
                              'has-error': $v.multi_master_cabang.$error
                            }"                          
                          ></multiselect>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="usename" class="font-weight-bold">Username</label>
                          <input 
                            type="text" 
                            class="form-control" 
                            id="usename" 
                            placeholder="Username Petugas" 
                            v-model="formData.username"
                            :class="{
                              'is-invalid': $v.formData.username.$error
                            }"
                          />
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="pass" class="font-weight-bold">Password</label>
                          <input 
                            type="password" 
                            class="form-control" 
                            id="pass" 
                            v-model="formData.password"
                          />
                        </div>
                      </div>
                      <CCol sm="12 mb-4 pl-0">
                        <label for class="font-weight-bold">Status</label>
                        <br />
                        <div class="d-flex align-items-center">
                          <div
                            class="custom-control custom-radio custom-control-inline"
                          >
                            <input
                              type="radio"
                              class="custom-control-input"
                              name="customRadio"
                              id="aktif"
                              value="1"
                              v-model="formData.status"
                              checked
                            />
                            <label class="custom-control-label" for="aktif"
                              >Aktif</label
                            >
                          </div>
                          <div
                            class="custom-control custom-radio custom-control-inline"
                          >
                            <input
                              type="radio"
                              class="custom-control-input"
                              name="customRadio"
                              id="tidak_aktif"
                              value="0"
                              v-model="formData.status"
                            />
                            <label
                              class="custom-control-label"
                              for="tidak_aktif"
                              >Tidak Aktif</label
                            >
                          </div>
                        </div>
                      </CCol>
                      <Button class="btn btn-md btn-success px-4 py-2 float-right" color="success" @click="postData">
                        Ubah
                      </Button>
                    </div>
                  </div>
                  <div class="col-md-4 order-1 order-sm-1 order-md-2 order-lg-2 order-xl-2">
                    <div class="text-center mt-3">
                      <img
                        :src="fileUrl != '' ? fileUrl : `${baseUrl}/files?filename=${formData.foto}&path=users`"
                        style="width:120px"
                        class="card-img-top img img-responsive rounded-circle elevation-2 border"
                        alt="User Picture"
                        @error="imgError"
                      />
                      <div class="mt-2">
                        <div class="upload-btn-wrapper">
                          <button class="btn-upload">Unggah Gambar</button>
                          <input 
                            type="file" 
                            name="myfile"  
                            @change="uploadImage($event)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required, email } from "vuelidate/lib/validators";
import { UploadImage } from '@/mixins/UploadImage';
import { AlertUtils } from "@/mixins/AlertUtils";
import { Cabang } from "@/mixins/master/Cabang";
import { Divisi } from "@/mixins/master/Divisi";
import PetugasLmsService from "@/services/user-manajemen/petugas-lms.service";
import permissionsMixins from "@/mixins/petugasIapi/permissionsMixins";
import BaseUrl from "@/services/base-url";

export default {
  mixins: [
    AlertUtils, 
    Cabang, 
    Divisi,
    UploadImage,
    permissionsMixins
  ],
  data: function() {
    return {
      multi_master_divisi : [],
      formData: [
        {
          username: "",
          name: "",
          email: "",
          password: "",
          noTelephone: "",
          status: "",
          foto: "",
          tipePetugas: "lms",
          divisi: {},
          cabang: {}
        }
      ],
      fileUrl: ''
    };
  },

  validations: {
    formData: {
      name: { required },
      username: { required },
      email: { required, email },      
    },
    multi_master_cabang: { required },
    multi_master_divisi: { required },
  },  

  mounted() {
    this.baseUrl = BaseUrl();
    const id = this.$route.params.id_user;
    this.getAllDivisi();
    this.getAllCabang();  
    this.getDetailPetugasIapi(id);
  },

  methods: {
    imgError(e) {
      e.target.src = '/img/avatars/2.jpeg'
    },
    getDetailPetugasIapi(id) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      PetugasLmsService.getDetailPetugasLms(id)
        .then(response => {                              
          this.formData = response.data.data[0];  
          setTimeout(() => {
            this.multi_master_divisi = this.optionMasterDivisi.find(el => el.idDivisi === this.formData.divisi.id_divisi);
            this.formData.idDivisi = this.formData.divisi.id_divisi;      
            this.multi_master_cabang = this.optionMasterCabang.find(el => el.idCabang === this.formData.cabang.id_cabang);          
            this.formData.idCabang = this.formData.cabang.id_cabang;
          }, 1000);
          this.formData.password = ""
          loader.hide();
        })
        .catch(error => {
          // comment console console.log(error)
          loader.hide();
        })
    },

    uploadImage(e) {
      let file = e.target.files[0];            
      let limit = 1024 * 1024 * 2;
      if(file['size'] > limit){
        this.alertError("File yang anda upload terlalu besar.")
        return false;
      }

      this.formData.foto = file

      var reader = new FileReader();
      var vm = this;      
      reader.onload = (file) => {
        this.fileUrl = reader.result;
      };

      reader.readAsDataURL(file);
    },

    postData() {                       
      this.$v.$touch();
      if (this.$v.$invalid) {
        window.scrollTo({top: 0, behavior: 'smooth'});
        return;
      } else {          
        this.putData();
      }      
    },    

    putData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });         

      if (typeof this.formData.foto === "string") {
        delete this.formData.foto;
      }

      if (this.formData.foto === null) {
        delete this.formData.foto;
      }    

      PetugasLmsService.putPetugasLms(this.formData)
        .then((response) => {          
          loader.hide();
          this.alertSuccess();          
          this.$router.push({ path: "/user-manajemen/petugas-lms-aktif" });
        })
        .catch((error) => {
          this.alertError(error.response.data.message);
          loader.hide();
        })      
    },    

    pilihDivisi(value) {
      this.formData.idDivisi = value.idDivisi;      
    },

    pilihCabang(value) {
      this.formData.idCabang = value.idCabang;      
    },
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>